<app-software-main-version></app-software-main-version>
<app-software-update-history></app-software-update-history>
